<script>
import { isNil, isEmpty } from 'lodash'
import drushim_lodash from 'lodash'
import TopBoardCompany from '@/components/Company/TopBoardCompany'
import AboutCompany from '~/components/Company/AboutCompany'
import JobsInCompany from '@/components/Company/JobsInCompany'
import ReasonsToJoin from '@/components/Company/ReasonsToJoin'
import GoogleMap from '@/components/Company/GoogleMap'
import CalculateDistance from '@/components/Company/CalculateDistance'
import CompanyLocation from '@/components/Company/CompanyLocation'
import CompanyDetails from '@/components/Company/CompanyDetails'
import WorkersSayings from '@/components/Company/WorkersSayings'

export default {
  components: {
    AboutCompany,
    TopBoardCompany,
    JobsInCompany,
    ReasonsToJoin,
    GoogleMap,
    CalculateDistance,
    CompanyLocation,
    CompanyDetails,
    WorkersSayings
  },

  props: {
    numOfEmployees: {
      type: String
    },
    numOfBranches: {
      type: Number
    },

    industry: {
      type: String
    },

    logo: {
      type: String
    },

    images: {
      type: Array
    },

    lat: {
      type: Number,
      required: true,
      default: 32.279476
    },
    lng: {
      type: Number,
      required: true,
      default: 34.86024
    },
    description: {
      type: String
    },
    companyName: {
      type: String
    },
    companyDisplayUrl: {
      type: String
    },
    companyCode: {
      type: String
    },
    address: {
      type: String
    },
    benefits: {
      type: Array
    },
    CustomBenefit: {
      type: String
    },
    jobs: {
      type: Array
    },
    categories: {
      type: Object
    },

    testimonials: {
      type: Array
    },
    screenWidth: {
      type: Number
    },
    showMoreJobs: {
      type: Boolean
    }
  },

  data() {
    return {
      shortListDisplay: true,
      showMoreButton: undefined
    }
  },

  mounted() {
    this.showMoreButton = this.showMoreJobs
  },

  computed: {
    ssa() {
      return drushim_lodash.get(this.$ssa, 'vm', {})
    },

    jobsList() {
      return this.jobs
    },

    displayAboutCompanySection() {
      return isNil(this.description) ? false : true
    },

    displayJobsSection() {
      return isEmpty(this.jobs) ? false : true
    },

    displayCompanyBenefits() {
      return isEmpty(this.benefits) && isEmpty(this.testimonials) ? false : true
    },

    displayOnMap() {
      return isEmpty(this.address) ? false : true
    },

    isMobile() {
      return this.$vuetify.breakpoint.xsOnly
    }
  },

  methods: {
    sendSSA(evenData) {
      this.ssa.logResponse('LogSSA', evenData)
    },
    loadMoreJobs() {
      this.shortListDisplay = false
      this.showMoreButton = false
      return this.jobsList
    }
  },

  beforeDestroy() {
    this.shortListDisplay = true
  }
}
</script>
